import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'liberro-switch',
  standalone: false,
  templateUrl: './liberro-switch.component.html',
  styleUrl: './liberro-switch.component.less'
})
export class LiberroSwitchComponent {
  @Input() public value!: boolean;
  @Input() public label = '';
  @Input() public disabled = false;
  @Output() private valueChanged = new EventEmitter<boolean>();

  public handleValueChange(): void {
    this.valueChanged.emit(!this.value);
  }

}
